/* eslint-disable no-restricted-globals */
import * as types from '../../mutationTypes';
import sessionManager from './sessionManager';

export default {
  /* eslint-disable no-param-reassign */
  [types.RESET_SESSION](state) {
    state.idpUri = '';
    state.redirectUri = '';
    state.fqdn = '';
    state.subdomain = '';
    state.tokenExpiry = 0;
    state.refreshToken = false;
    state.interruptRefreshToken = false;
    state.profile = {
      displayName: '',
      name: {
        familyName: '',
        givenName: ''
      },
      email: ''
    };
    state.initialised = false;
  },

  [types.SET_SUBDOMAIN](state, value) {
    state.subdomain = value;
  },

  [types.SET_IDP_URI](state, value) {
    state.idpUri = value;
  },

  [types.SET_FQDN](state, value) {
    state.fqdn = value;
  },

  [types.SET_REDIRECT_URI](state, value) {
    state.redirectUri = value;
  },

  [types.SET_REFRESH_TOKEN](state, value) {
    state.refreshToken = value;
  },

  [types.SET_INTERRUPT_REFRESH_TOKEN](state, value) {
    state.interruptRefreshToken = value;
  },

  [types.SET_TOKEN_EXPIRY](state, value) {
    let tokenExpiry = value;
    // if (typeof value !== 'number') role = 1;
    if (isNaN(value)) tokenExpiry = 0;
    state.tokenExpiry = tokenExpiry;
  },

  [types.SET_PROFILE](state, value) {
    state.profile = value;
  },

  [types.SET_SESSION_INITIALISED](state, value) {
    state.initialised = value;
  },

  [types.SET_TOKEN](state, token) {
    state.token = token;
  },

  [types.SET_IS_FIRST_LOGIN](state, value) {
    state.isFirstLogin = value;
  },

  [types.SET_IS_LOGIN_BANNER_SHOWN](state, value) {
    state.isLoginBannerShown = value;
  },

  [types.SET_SUPPORT_MODE](state, value) {
    state.isSupportMode = value;
  },

  [types.SET_TARGET_SITE](state, value) {
    state.targetSite = value || null;
    if (value) {
      sessionManager.setTargetSite(value);
    } else {
      sessionManager.clearTargetSite();
    }
  }
  /* eslint-enable no-param-reassign */
};
